import type { NavigationItem } from "@/types/navigation";
import { Gift, Trophy, Users } from "lucide-react";

/**
 * Main navigation items - shared between desktop sidebar and mobile bottom nav
 */
export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    title: "Quests",
    url: "/",
    icon: Trophy,
  },
  {
    title: "Rewards",
    url: "/rewards",
    icon: Gift,
  },
  {
    title: "Referral",
    url: "/referral",
    icon: Users,
  },
];

/**
 * Mobile navigation items - same as desktop navigation
 */
export const MOBILE_NAVIGATION_ITEMS: NavigationItem[] = NAVIGATION_ITEMS;
